import {
  CHALLENGE_HEADER_KEY,
  CHALLENGE_HEADER_VALUE,
  FORBIDDEN_STATUS_CODE,
  RATE_LIMITED_STATUS_CODE,
} from './constants';

export function isForbiddenOrRateLimited(status: number): boolean {
  return (
    status === FORBIDDEN_STATUS_CODE || status === RATE_LIMITED_STATUS_CODE
  );
}

export function isChallengeResponse(response: Response): boolean {
  return (
    isForbiddenOrRateLimited(response.status) &&
    response.headers.get(CHALLENGE_HEADER_KEY) === CHALLENGE_HEADER_VALUE
  );
}
